/**
 * Texto del aviso de atribución de la oferta MS2 (sin JSX, para poder testearlo
 * y reusarlo sin romper el fast refresh del componente que lo muestra).
 *
 * Regla del server (2026-09-14, caso ETCHEVERRY): cualquier acción sobre el
 * link de la oferta —copiar, enviar/reenviar por mail, generar/regenerar el link
 * de pago— deja la venta atribuida a quien la hace, aunque el link vigente lo
 * haya generado otro agente. Este aviso se lo dice ANTES de hacerlo.
 */

/** Agente al que hoy está atribuida la oferta (o el pago). */
export interface AgenteAtribuido {
  nombre?: string;
  email?: string;
}

/** Qué está por hacer el agente sobre el link. Cambia el verbo del aviso. */
export type AccionSobreLink = 'link' | 'mail' | 'pago';

export function textoAvisoAtribucion(
  accion: AccionSobreLink,
  atribuidoA?: AgenteAtribuido | null,
  yoEmail?: string | null,
): { principal: string; detalle: string | null } {
  const principal =
    accion === 'pago'
      ? 'Este contacto se te va a atribuir si el titular paga desde este link.'
      : 'Este contacto se te va a atribuir si el titular acepta la oferta desde este link.';
  const quien = atribuidoA?.nombre?.trim() || atribuidoA?.email?.trim() || '';
  if (!quien) return { principal, detalle: null };
  const yo = (yoEmail ?? '').trim().toLowerCase();
  const esMio = yo !== '' && (atribuidoA?.email ?? '').trim().toLowerCase() === yo;
  if (esMio) return { principal, detalle: 'Hoy ya está atribuido a vos.' };
  return {
    principal,
    detalle: `Hoy está atribuido a ${quien}. Al continuar pasa a estar atribuido a vos.`,
  };
}
